import { DEFAULT_LIMIT, DEFAULT_OFFSET } from '../constants';
import buildSortValues from './build-sort-values';

const getCorrectSort = (relations, filterProps, stringProps, useSortObject) => {
  const { sort, sortby, sortProperties = [] } = filterProps;

  return buildSortValues(
    [{ sort, propsToDisplay: sortby }, ...sortProperties],
    relations,
    stringProps,
    useSortObject
  );
};

const getGenericRenderVariables = ({
  relations,
  filterProps = {},
  stringProps = [],
  rawQuery = {},
  useRandomSort = false
}) => {
  const rawQueryCopy = { ...rawQuery };
  const { limit = DEFAULT_LIMIT, offset } = filterProps;
  const limitToUse = Number(limit || DEFAULT_LIMIT);
  const offsetToUse = Number(offset || DEFAULT_OFFSET);

  if (useRandomSort) {
    const rawQueryStringified = JSON.stringify({
      query: {
        function_score: {
          query: rawQueryCopy && rawQueryCopy.query ? rawQueryCopy.query : rawQueryCopy,
          random_score: {},
          boost_mode: 'replace'
        }
      }
    });

    return {
      limit: limitToUse,
      offset: offsetToUse,
      rawQueryStringified
    };
  }

  const sort = getCorrectSort(relations, filterProps, stringProps, !!rawQueryCopy.sort);

  if (rawQueryCopy.sort && sort) {
    rawQueryCopy.sort = [...rawQueryCopy.sort, sort];

    return {
      limit: limitToUse,
      offset: offsetToUse,
      rawQueryStringified: JSON.stringify(rawQueryCopy)
    };
  }

  return {
    limit: limitToUse,
    offset: offsetToUse,
    ...sort,
    rawQueryStringified: JSON.stringify(rawQueryCopy)
  };
};

export default getGenericRenderVariables;
